export const config = {
  "url_prefix" : "https://kanali.mochi.gdn",
  "self_url" : "https://kanali.menus.mochi.gdn",
  "show_icons" : true,	
  "debug": true
}

